module.exports = __webpack_public_path__ + "img/kairan.1c844db8.jpg";